import React from 'react';
import {Paper, Stack, Typography} from '@mui/material';

import CurrentInvoices from './CurrentInvoices';
import PastInvoices from './PastInvoices';

const Invoice = () => {
    return (
        <Stack direction={'column'} sx={{width: '100%', height: '100%'}}>
            <Paper
                sx={{
                    width: '100%',
                    height: 'fit-content',
                    borderRadius: '8px',
                    boxShadow: 'none'
                }}
            >
                <Typography variant="h5" fontSize={'16px'} lineHeight={'24px'} fontWeight={'fontWeightMedium'} sx={{flexGrow: 1}} p="16px">
                    Invoices
                </Typography>
                <CurrentInvoices />
                <PastInvoices />
            </Paper>
        </Stack>
    );
};

export default Invoice;
